import { useMediaQuery } from 'styled-breakpoints/use-media-query';
import { useTheme } from 'styled-components';
import { useMemo } from 'react';

import { Box } from 'components/Box';
import { StripGraph } from 'components/Chart';

import { FlexContainer } from 'components/FlexContainer';
import { SummaryTable } from './SummaryTable';
import { CalculationSummaryHeader } from '../CalculationSummaryHeader';

import type { FC, ReactNode } from 'react';
import type { StripProps } from 'components/Chart/StripGraph/types';
import type { SummaryItem } from './types';

interface CalculationSummaryProps {
  headerAmount: string | ReactNode;
  title: string;
  summary?: SummaryItem[];
  showCharts?: boolean;
}

export const CalculationSummary: FC<CalculationSummaryProps> = ({
  title,
  headerAmount,
  summary,
  showCharts = true,
}) => {
  const { breakpoints } = useTheme();

  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const sections: StripProps[] = useMemo(() => {
    if (!summary) return [];

    return summary?.map(({ percentage, color }) => ({ percentage, color }));
  }, [summary]);

  return (
    <Box
      paddingLeft={isMobile ? 3 : 15}
      paddingRight={isMobile ? 3 : 15}
      paddingTop={5}
      paddingBottom={10}
    >
      <FlexContainer direction="column">
        <CalculationSummaryHeader title={title}>{headerAmount}</CalculationSummaryHeader>
        {showCharts && <StripGraph sections={sections} />}
        {showCharts && summary && <SummaryTable summary={summary} />}
      </FlexContainer>
    </Box>
  );
};
